import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Unity } from 'react-unity-webgl';
import { useMeasure, useMount } from 'react-use';
import { useUnity } from '../context/UnityProvider';
import { sendToUnity } from '../utils/bridge';
import { handleCustomEvent } from './Viewer.custom';
import { useFrameInner, useShortkeys } from './Viewer.hooks';
import { Wrapper } from './Viewer.style';
import { Event, Stage } from './Viewer.types';
import { log } from './Viewer.utils';

export type ViewerProps = {
  buildUrl: string;
};

export function Viewer(props: ViewerProps) {
  const { buildUrl } = props;
  const { instanceId = 'default' } = useParams();
  const [searchParams] = useSearchParams();
  const unityVersion = searchParams.get('unityVersion') || 'stable';
  const [ref, { width, height }] = useMeasure<HTMLDivElement>();

  function onReceive(ev: any) {
    const { type, message, data } = ev;

    if (type === 'UnityBridge2') {
      log(Stage.INNER_INSTRUCTIONS);
      if (handleCustomEvent(message, data)) return;
      sendToUnity(message, data);
    }
  }

  const sendMessage = useFrameInner(instanceId, onReceive);

  function onUnity(instanceId: string, eventName: string, data: any) {
    sendMessage({ type: eventName, data, instanceId });
  }

  const { unityProvider, isLoaded } = useUnity(
    instanceId,
    {
      buildUrl,
      // @ts-ignore
      unityVersion,
    },
    onUnity
  );

  useMount(() => {
    sendMessage({ type: 'LIFECYCLE', verb: Event.INIT });
  });

  useEffect(() => {
    if (!isLoaded) return;
    log(Stage.INNER_LOADED);
    sendMessage({ type: 'LIFECYCLE', verb: Event.LOADED });
  }, [isLoaded]);

  useShortkeys(sendMessage);

  return (
    <Wrapper className='Viewer-wrapper' data-testid='Viewer-wrapper' ref={ref}>
      <Unity
        unityProvider={unityProvider}
        style={{
          height,
          width,
        }}
        matchWebGLToCanvasSize={true}
        devicePixelRatio={devicePixelRatio}
      />
    </Wrapper>
  );
}

export default Viewer;
